import { domain, stateTree } from 'modules/data';
import { createSelector } from 'reselect';

export const getPracticeInvitations: (state: stateTree.State) => domain.PracticeInvitation[] = createSelector(
    (state: stateTree.State) => state.entities.practiceInvitations,
    (practiceInvitations) => {
        return Object.values(practiceInvitations);
    }
);
